import { DOCS, getDocById, resolveDocId, STORAGE } from "./constants";
import type { AppState, CommentFilter, DocDefinition, ReviewComment } from "./types";

function readScrollPositions(): Record<string, number> {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE.scrollPositions) || "{}");
    return typeof parsed === "object" && parsed ? parsed : {};
  } catch {
    return {};
  }
}

export function initialDocId(): string {
  return availableDocId(localStorage.getItem(STORAGE.currentDoc));
}

export function availableDocId(saved: string | null, fallback = "meta.brief"): string {
  const resolved = resolveDocId(saved || fallback);
  return getDocById(resolved) ? resolved : fallback;
}

export function createInitialState(): AppState {
  return {
    session: { authenticated: false, role: null, isAdmin: false },
    view: "document",
    currentDocId: initialDocId(),
    comments: [],
    allComments: [],
    filter: "all",
    boardDocId: "all",
    quote: null,
    replyTarget: null,
    markdownCache: new Map(),
    scrollPositions: readScrollPositions(),
    editor: null,
    contentRelease: new Map(),
  };
}

export function filterComments(
  comments: ReviewComment[],
  filter: CommentFilter,
  docId = "all",
): ReviewComment[] {
  const target = docId === "all" || docId === "home" ? docId : resolveDocId(docId);
  return comments.filter((comment) => {
    const statusMatches = filter === "all" || comment.status === filter;
    const commentDoc = comment.doc_id === "home" ? "home" : resolveDocId(comment.doc_id);
    const docMatches = target === "all" || commentDoc === target;
    return statusMatches && docMatches;
  });
}

export function saveScrollPosition(state: AppState, docId: string, position: number): void {
  state.scrollPositions[docId] = Math.max(0, Math.round(position));
  localStorage.setItem(STORAGE.scrollPositions, JSON.stringify(state.scrollPositions));
}

/** 按目录顺序取当前文档的前后篇（目录首尾各缺一侧）。 */
export function adjacentDocs(docId: string): {
  prev: DocDefinition | null;
  next: DocDefinition | null;
} {
  const index = DOCS.findIndex((doc) => doc.id === resolveDocId(docId));
  if (index < 0) return { prev: null, next: null };
  return {
    prev: DOCS[index - 1] ?? null,
    next: DOCS[index + 1] ?? null,
  };
}
